import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { torneosAPI } from "../services/api";
import { Torneo } from "../utils/types";

export function useTorneos(academiaId?: string) {
  return useQuery<Torneo[]>({
    queryKey: ["torneos", academiaId],
    queryFn: () => torneosAPI.listar(academiaId).then((r) => r.data),
    enabled: true,
  });
}

export function useTorneo(id: string) {
  return useQuery<Torneo>({
    queryKey: ["torneo", id],
    queryFn: () => torneosAPI.obtener(id).then((r) => r.data),
    enabled: !!id,
  });
}

export function useTorneoTablaPosiciones(torneoId: string, grupo?: string) {
  return useQuery({
    queryKey: ["torneo-tabla", torneoId, grupo],
    queryFn: () => torneosAPI.tablaPosiciones(torneoId, grupo).then((r) => r.data),
    enabled: !!torneoId,
  });
}

export function useTorneoCalendario(torneoId: string, categoriaId?: string) {
  return useQuery({
    queryKey: ["torneo-calendario", torneoId, categoriaId],
    queryFn: () => torneosAPI.calendario(torneoId, categoriaId).then((r) => r.data),
    enabled: !!torneoId,
  });
}

export function useCrearTorneo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<Torneo>) => torneosAPI.crear(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["torneos"] }),
  });
}

export function useInscribirCategoria(torneoId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: { categoria_id: string; grupo?: string }) =>
      torneosAPI.inscribirCategoria(torneoId, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["torneo-tabla", torneoId] });
      qc.invalidateQueries({ queryKey: ["categoria-torneos"] });
    },
  });
}
